<template>
  <section-page
    title="Email Signature"
    description="Create a custom signature that we will append to the bottom of every email you send out of Forefront"
  >
    <form-field-editor
      v-model="form.email_signature"
      type="signature"
    ></form-field-editor>

    <div class="flex flex-end">
      <button-default :async-click="saveSignature">Save Signature</button-default>
    </div>
  </section-page>
</template>

<script>
export default {
  name: "ProfileEmailSignature",
  data() {
    return {
      validationErrors: {},
      form: {
        id: null,
        email_signature: '',
      }
    }
  },
  created() {
    let user = this.$utils.clone(this.$store.getters.authUser);
    this.form.id = user.id;
    this.form.email_signature = user.email_signature;
  },
  methods: {
    saveSignature() {
      return this.$api.users.updateEmailSignature(this.form, this.validationErrors)
        .then(() => {
          this.$buefy.toast.open({
            message: "Email Signature was saved",
            type: 'is-success'
          });
        });
    }
  },
}
</script>
